import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PageWrapper from '../../../components/PageWrapper';
import { RiArrowLeftSLine } from 'react-icons/ri';
import ChangeSupplier from './components/ChangeSupplier';
import { getSingleSupplierDetails } from '../../../Actions/supplierActions';
import ErrorEmptyStateView from '../../../components/ErrorEmptyStateView';
import { useQuery } from '@tanstack/react-query';
import Spinner from '../../../components/Spinner';
import ChangeSupplierStatus from './components/ChangeSupplierStatus';
import SupplierTabs from './components/SupplierTabs';
const SupplierDetails = () => {
  const { id, type } = useParams();
  const {
    data: supplierDetails,
    isLoading: supplierDetailsLoading,
    error: supplierDetailsError,
  } = useQuery({
    queryKey: ['supplier-details', id],
    queryFn: () => getSingleSupplierDetails({ supplierID: id }),
    enabled: !!id,
  });

  return (
    <PageWrapper>
      {supplierDetailsLoading ? (
        <div className="flex items-center justify-center h-[90dvh]">
          <Spinner />
        </div>
      ) : supplierDetailsError ? (
        <div className="flex items-center justify-center h-[90dvh]">
          <ErrorEmptyStateView type="error" />
        </div>
      ) : (
        <div className="space-y-5  ">
          <div className="bg-gray-25  flex justify-between items-center  p-[24px_32px_18px_32px]  border-b-2">
            <div className="flex gap-[8px]">
              <Link to="/suppliers">
                <RiArrowLeftSLine size={28} />
              </Link>

              <div className="space-y-[8px]">
                <div className="flex items-center gap-2 ">
                  <span className="text-lg font-bold">Supplier Profile -</span>

                  <ChangeSupplier
                    _id={id}
                    type={type}
                    supplierName={supplierDetails?.supplierName || ''}
                  />
                </div>
                <p className="text-sm text-gray-600 font-[400]">
                  Keep track of Accounts and their activities from here.
                </p>
              </div>
            </div>

            <ChangeSupplierStatus
              _id={id}
              supplierStatus={supplierDetails?.isActive ? 1 : 2}
            />
          </div>
          <div className="px-6 pb-[20px]">
            <SupplierTabs supplierID={id} />
          </div>
        </div>
      )}
    </PageWrapper>
  );
};

export default SupplierDetails;
